import { render, staticRenderFns } from "./CallAgora.vue?vue&type=template&id=ffee75a4&"
import script from "./CallAgora.vue?vue&type=script&lang=js&"
export * from "./CallAgora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports